export default {
  wrapper: {
    margin: ['12px 0 0 0', '38px 0 0 0', '38px 0 0 0'],
    padding: ['0 15px', '0', '0'],
    color: '#333D47',

    'h1, h2, h3': {
      margin: '0',
      fontFamily: 'spoqaRegular',
      padding: ['0 0', '0 10px', '0 30px'],
    },
    h2: {
      fontSize: ['14px', '16px', '24px'],
    },
    h3: {
      fontSize: ['12px', '16px', '20px'],
    },
    p: {
      fontSize: ['14px', '16px', '24px'],
    },
    strong: {
      fontFamily: 'spoqaBold',
    },
  },
  checkboxLabel: {
    fontSize: ['14px', '16px', '24px'],
    fontFamily: 'spoqaBold',

    'input:checked + svg': {
      color: '#000',
    },

    'svg:last-child': {
      background: '#D9D9D9',
      path: { fill: '#D9D9D9' },
      clipPath: 'inset(5% 10% 15% 10%)',
    },
  },
  checkboxErrorLabel: {
    'svg:last-child': {
      background: '#E70041',
      path: { fill: '#E70041' },
      clipPath: 'inset(5% 10% 15% 10%)',
    },
  },
  checkboxText: {
    fontSize: ['14px', '16px', '20px'],
    margin: ['17px 0 0 0', '30px 0 0 0', '17px 0 0 0'],
    padding: ['0 20px', '0 5px', '0 30px'],
    fontFamily: 'spoqaRegular',
  },
  formTextError: {
    display: 'block',
    fontSize: '14px',
    color: 'sideNavRed',
    margin: ['', '', '5px 0 0 0'],
    padding: ['', '0 30px'],
  },
  scrollTable: {
    maxHeight: ['205px', '305px', '340px'],
    overflowY: 'scroll',
    scrollBehavior: 'smooth',
  },
}
